import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "topbar"
};
const _hoisted_2 = {
  class: "header-filters",
  gap: 28
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "DSP Reporting", -1);
const _hoisted_4 = {
  class: "toolbar"
};
const _hoisted_5 = {
  class: "navigation-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dsp_filters = _resolveComponent("dsp-filters");
  const _component_currency_filter = _resolveComponent("currency-filter");
  const _component_navigation_tabs = _resolveComponent("navigation-tabs");
  const _component_period_controllers = _resolveComponent("period-controllers");
  const _component_overview_table = _resolveComponent("overview-table");
  const _component_conversion_period_table = _resolveComponent("conversion-period-table");
  const _component_consideration_period_table = _resolveComponent("consideration-period-table");
  const _component_loyalty_period_table = _resolveComponent("loyalty-period-table");
  const _component_flex_column = _resolveComponent("flex-column");
  const _component_product_table = _resolveComponent("product-table");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  return _openBlock(), _createBlock(_component_omny_ui_layout, {
    "content-padding": "0",
    class: "dsp-reporting"
  }, {
    topbar: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_dsp_filters)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_currency_filter, {
      currencies: _ctx.currencies,
      "only-mode": "",
      onApply: $options.handleApplyForCurrencyChange
    }, null, 8, ["currencies", "onApply"])])])]),
    "topbar-sub": _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_navigation_tabs, {
      tabs: $options.computedTabs,
      modelValue: $options.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.tab = $event)
    }, null, 8, ["tabs", "modelValue"])])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["dsp-reporting-contents", [_ctx.floatingTableState]])
    }, [_createVNode(_component_flex_column, {
      gap: 24,
      classes: "all-wrapper"
    }, {
      default: _withCtx(() => [_ctx.currentTabValue === 'overview' ? (_openBlock(), _createBlock(_component_overview_table, {
        key: 0,
        loading: $data.overviewTableLoading
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.overviewPeriod,
          "onUpdate:period": _cache[1] || (_cache[1] = $event => $options.overviewPeriod = $event),
          periodSelectorOptions: _ctx.overviewPeriodSelectorOptions
        }, null, 8, ["period", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading"])) : _createCommentVNode("", true), _ctx.currentTabValue === 'conversion' ? (_openBlock(), _createBlock(_component_conversion_period_table, {
        key: 1,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[4] || (_cache[4] = $event => this.refreshMediator(['PERIOD_TABLE', 'PRODUCT_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[2] || (_cache[2] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[3] || (_cache[3] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true), _ctx.currentTabValue === 'consideration' ? (_openBlock(), _createBlock(_component_consideration_period_table, {
        key: 2,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[7] || (_cache[7] = $event => this.refreshMediator(['PERIOD_TABLE', 'PRODUCT_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[5] || (_cache[5] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[6] || (_cache[6] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true), _ctx.currentTabValue === 'loyalty' ? (_openBlock(), _createBlock(_component_loyalty_period_table, {
        key: 3,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[10] || (_cache[10] = $event => this.refreshMediator(['PERIOD_TABLE', 'PRODUCT_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[8] || (_cache[8] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[9] || (_cache[9] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true)]),
      _: 1
    }), _ctx.currentTabValue !== 'overview' ? (_openBlock(), _createBlock(_component_product_table, {
      key: 0,
      loading: $data.productTableLoading,
      onRefreshOtherKpis: _cache[11] || (_cache[11] = $event => this.refreshMediator(['PERIOD_TABLE'])),
      onRefresh: _cache[12] || (_cache[12] = $event => $options.refreshProductTable()),
      onHandleSort: $options.handleProductTableSort,
      onChangeDate: $options.handleDateChange,
      onRestoreEvolutionTable: $options.restoreEvolutionTable
    }, null, 8, ["loading", "onHandleSort", "onChangeDate", "onRestoreEvolutionTable"])) : _createCommentVNode("", true)], 2)]),
    _: 1
  });
}